import { IonModal } from '@ionic/react'
import React, { FC } from 'react'
import { UseHeader } from '@cps'
import Map from '../Map'
import './index.scss'
import { toast } from '@utils'

interface IProps {
  mapType: 'baidu' | 'google';
  center?: any;
  reject?: any;
  resolve?: any;
}

const AddressMapModal: FC<IProps> = ({ mapType, center, reject, resolve }) => {
  const handleError = (info) => {
    if (info.error) {
      toast({ message: info.message || i18n.t('location.notOpenLBSTip') })
    }
  }
  return (
    <IonModal
      cssClass='address-modal'
      isOpen
    >
      <UseHeader title={i18n.t('location.confirmShippingAddress')} onBack={reject}></UseHeader>
      <Map
        mapType={mapType}
        center={center}
        onSelectAddress={(info: any) => resolve(info)}
        onError={(error: any) => handleError(error)}
      >
      </Map>
    </IonModal>
  )
}

export default AddressMapModal
